<div class="auth-page">
  <!-- Left Side - Branding -->
  <div class="auth-hero">
    <div class="auth-hero__icons">
      <i class="pi pi-building hero-icon hero-icon--1"></i>
      <i class="pi pi-users hero-icon hero-icon--2"></i>
      <i class="pi pi-calendar hero-icon hero-icon--3"></i>
      <i class="pi pi-heart hero-icon hero-icon--4"></i>
      <i class="pi pi-map-marker hero-icon hero-icon--5"></i>
      <i class="pi pi-comments hero-icon hero-icon--6"></i>
      <i class="pi pi-home hero-icon hero-icon--7"></i>
      <i class="pi pi-star hero-icon hero-icon--8"></i>
      <i class="pi pi-bell hero-icon hero-icon--9"></i>
      <i class="pi pi-shopping-bag hero-icon hero-icon--10"></i>
      <i class="pi pi-car hero-icon hero-icon--11"></i>
      <i class="pi pi-sun hero-icon hero-icon--12"></i>
    </div>
    <div class="auth-hero__content">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-hero__logo" />
      <h1 class="auth-hero__title">Regional Hub</h1>
      <p class="auth-hero__subtitle">Entdecke was in deiner Region passiert. Verbinde dich mit deiner Gemeinde, entdecke lokale Events und bleibe immer informiert.</p>
    </div>
    <div class="auth-hero__footer">
      <span>Meine Kommune</span>
    </div>
  </div>

  <!-- Right Side - Login Card -->
  <div class="auth-card">
    <!-- Mobile Header -->
    <div class="auth-card__mobile-header">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-card__mobile-logo" />
      <p class="auth-card__mobile-brand">Meine Kommune</p>
      <h1 class="auth-card__mobile-title">Regional Hub</h1>
    </div>

    <h2 class="auth-card__heading">Anmelden</h2>
    <p class="auth-card__subheading">Melde dich an um fortzufahren</p>

    <form [formGroup]="loginForm" (ngSubmit)="performStandardLogin()">
      <div class="auth-field">
        <label>E-Mail</label>
        <input type="email" placeholder="name@beispiel.de" formControlName="email" autocomplete="email"/>
      </div>

      <div class="auth-field">
        <label>Passwort</label>
        <div class="auth-field__password">
          <input [type]="showPassword ? 'text' : 'password'" placeholder="Passwort eingeben" formControlName="password" autocomplete="current-password" (keyup.enter)="performStandardLogin()"/>
          <button type="button" (click)="showPassword = !showPassword">
            <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <button type="button" class="auth-forgot" (click)="isPasswordResetRequestVisible = true">Passwort vergessen?</button>

      <button type="submit" class="auth-btn" [disabled]="isLoginInitiated">
        <span *ngIf="!isLoginInitiated">Anmelden</span>
        <i *ngIf="isLoginInitiated" class="pi pi-spinner pi-spin"></i>
      </button>
    </form>

    <div class="auth-divider"><span>oder</span></div>

    <a routerLink="/auth/register" class="auth-btn auth-btn--outline">Konto erstellen</a>
  </div>
</div>

<!-- Password Reset Request -->
<p-drawer [(visible)]="isPasswordResetRequestVisible" position="bottom" [style]="{ height: 'auto', maxHeight: '90vh' }" [showCloseIcon]="false" styleClass="auth-drawer">
  <ng-template pTemplate="header">
    <div class="auth-sheet__handle"></div>
  </ng-template>
  <div class="auth-sheet">
    <div class="auth-sheet__icon"><i class="pi pi-envelope"></i></div>
    <h2>Passwort zurücksetzen</h2>
    <p>Wir senden dir einen Link per E-Mail</p>

    <form [formGroup]="passwordResetRequestForm">
      <div class="auth-field">
        <label>E-Mail</label>
        <input type="email" placeholder="name@beispiel.de" formControlName="email" autocomplete="email"/>
      </div>
      <button type="button" class="auth-btn" (click)="performPasswordResetRequest()" [disabled]="isPasswordResetRequestInitiated">
        <span *ngIf="!isPasswordResetRequestInitiated">Link senden</span>
        <i *ngIf="isPasswordResetRequestInitiated" class="pi pi-spinner pi-spin"></i>
      </button>
    </form>
  </div>
</p-drawer>

<!-- Password Reset Form -->
<p-drawer [(visible)]="isPasswordResetVisible" position="bottom" [style]="{ height: 'auto', maxHeight: '90vh' }" [showCloseIcon]="false" styleClass="auth-drawer">
  <ng-template pTemplate="header">
    <div class="auth-sheet__handle"></div>
  </ng-template>
  <div class="auth-sheet">
    <div class="auth-sheet__icon"><i class="pi pi-lock"></i></div>
    <h2>Neues Passwort</h2>
    <p>Wähle ein sicheres Passwort</p>

    <form [formGroup]="passwordResetForm">
      <div class="auth-field">
        <label>Neues Passwort</label>
        <div class="auth-field__password">
          <input [type]="showNewPassword ? 'text' : 'password'" placeholder="Neues Passwort" formControlName="password" autocomplete="new-password"/>
          <button type="button" (click)="showNewPassword = !showNewPassword">
            <i [class]="showNewPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <ul class="password-hints">
        <li [class.valid]="hasUppercase(passwordResetForm.get('password')?.value)">
          <i [class]="hasUppercase(passwordResetForm.get('password')?.value) ? 'pi pi-check' : 'pi pi-times'"></i>
          Mindestens ein Großbuchstabe
        </li>
        <li [class.valid]="hasLowercase(passwordResetForm.get('password')?.value)">
          <i [class]="hasLowercase(passwordResetForm.get('password')?.value) ? 'pi pi-check' : 'pi pi-times'"></i>
          Mindestens eine Zahl
        </li>
        <li [class.valid]="hasMinLength(passwordResetForm.get('password')?.value, 8)">
          <i [class]="hasMinLength(passwordResetForm.get('password')?.value, 8) ? 'pi pi-check' : 'pi pi-times'"></i>
          Mindestens 8 Zeichen
        </li>
      </ul>

      <div class="auth-field">
        <label>Passwort bestätigen</label>
        <div class="auth-field__password">
          <input [type]="showConfirmPassword ? 'text' : 'password'" placeholder="Passwort wiederholen" formControlName="passwordConfirm" autocomplete="new-password" (keyup.enter)="performPasswordReset()"/>
          <button type="button" (click)="showConfirmPassword = !showConfirmPassword">
            <i [class]="showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <button type="button" class="auth-btn" (click)="performPasswordReset()" [disabled]="isPasswordResetInitiated || passwordResetForm.invalid">
        <span *ngIf="!isPasswordResetInitiated">Passwort ändern</span>
        <i *ngIf="isPasswordResetInitiated" class="pi pi-spinner pi-spin"></i>
      </button>
    </form>
  </div>
</p-drawer>
